import TextField from 'modules/core/components/TextField'
import { useFormContext } from 'modules/core/hooks/useForm'

import { WorkingConditionDisplayItemProps } from 'modules/contracts_settings/lib/useWorkConditionItemsCategories'
import { getI18nItemFieldKey } from 'modules/contracts_settings/lib/useWorkConditionItemsCategories'
import { WorkConditionVersionItemsFormData } from 'modules/contracts_settings/pages/WorkingConditionsVersionPage/forms'

const WorkingConditionItemTextField = ({ name, type }: WorkingConditionDisplayItemProps) => {
  const form = useFormContext<WorkConditionVersionItemsFormData>()

  return (
    <TextField
      type={type === 'number' ? 'number' : 'text'}
      label={getI18nItemFieldKey(name, 'label')}
      value={form.values.items[name]}
      onChange={(newValue) => form.setFieldValue('items.' + name, newValue)}
      error={form.touched.items?.[name] ? form.errors.items?.[name] : undefined}
    />
  )
}

export default WorkingConditionItemTextField
